import React, { Component } from "react";
import _findIndex from "lodash/findIndex";
import _some from "lodash/some";
import _get from "lodash/get";
import cx from "classnames";
//
import { _splice, formatMoney, getHumanDuration } from "../utils";
import { ButtonBasic } from "../components/Button";
import PremiumAlert from "./PremiumAlert";
import Alert from "../components/Alert";

class ModelRates extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: props.outcall ? "outcall" : "incall",
      outcallExpanded: false,
      incallExpanded: false,
    };
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   const oldModelId = _get(this.props, "model.id");
  //   const newModelId = _get(nextProps, "model.id");

  //   return Boolean(newModelId) && oldModelId !== newModelId;
  // }

  changeDuration(duration) {
    const { tab } = this.state;

    this.props.changeDuration({
      duration,
      outcall: tab === "outcall",
    });

    this.expandRates(tab);
  }

  getRates() {
    const { tab } = this.state;
    const { incalls, outcalls } = this.props;

    return tab === "outcall" ? outcalls : incalls;
  }

  isSubset() {
    const { tab, outcallExpanded, incallExpanded } = this.state;
    const isOutcall = tab === "outcall";

    return (isOutcall && !outcallExpanded) || (!isOutcall && !incallExpanded);
  }

  getSubset(rates) {
    const { duration } = this.props;

    let start;
    let end;

    start = end = _findIndex(rates, (rate) => rate.duration >= duration);

    start--;
    end++;

    if (start < 0) {
      start = 0;
    }

    if (start === 0 && end < 2) {
      end++;
    }

    if (end > rates.length) {
      end = rates.length - 1;
    }

    return rates.filter((rate, loop) => loop >= start && loop <= end);
  }

  insertRate(rates, duration) {
    const idx = _findIndex(rates, (rate) => rate.duration > duration);

    return _splice(rates, idx, 0, { id: "__duration__", duration });
  }

  expandRates(tab) {
    if (tab === "outcall") {
      this.setState({ outcallExpanded: true });
    } else {
      this.setState({ incallExpanded: true });
    }
  }

  render() {
    const {
      discounts,
      rate,
      isPremium,
      duration,
      offline,
      outcall,
      city,
      modelName,
      isComplimentaryCity,
    } = this.props;
    const { tab, outcallExpanded, incallExpanded } = this.state;

    let rates = this.getRates();

    if (!rate) {
      rates = this.insertRate(rates, duration);
    }

    const remaining = rates.length - 3;
    const isOutcall = tab === "outcall";

    if (this.isSubset()) {
      rates = this.getSubset(rates);
    }

    const expanded = isOutcall ? outcallExpanded : incallExpanded;
    const ratesAllowed = isOutcall || (!isOutcall && Boolean(city.incall));

    return (
      <div>
        <Tabs
          className="u-mb-small u-mt"
          tabs={[
            { id: "outcall", text: "OUTCALL" },
            { id: "incall", text: "INCALL" },
          ]}
          active={tab}
          onTabClick={(tab) => this.setState({ tab })}
        />
        {/* {!isPremium && (
          <PremiumAlert text="Exclusive rates available for _Premium members_." />
        )} */}

        {!Boolean(rate) && (
          <Alert
            error
            text={`_${modelName}_ does not accept **${getHumanDuration(
              duration
            )}** bookings`}
          />
        )}
        {ratesAllowed && (
          <div>
            {rates.length > 0 && (
              <div>
                <table className="table--details u-mb-small">
                  <thead>
                    <tr>
                      <th>Duration</th>
                      <th>Price</th>
                      {/* <th className="u-brand">Premium price</th> */}
                      <th>Shots</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {rates.map((rate) => {
                      const active =
                        rate.duration === duration &&
                        Boolean(rate.outcall) === outcall;

                      const disabled =
                        rate.id === "__duration__" ||
                        (rate.duration === 60 &&
                          !isPremium &&
                          !isComplimentaryCity);

                      let amount;
                      let amountDiscounted;

                      if (rate.amount) {
                        amount = formatMoney(rate.amount, city.country_id);
                      }

                      const discount = discounts[rate.duration] || 0;

                      if (amount && discount) {
                        amountDiscounted = formatMoney(
                          rate.amount - discount,
                          city.country_id
                        );
                      }

                      return (
                        <tr key={rate.id} className={cx({ active, disabled })}>
                          <td>{getHumanDuration(rate.duration)}</td>
                          <td
                          // className={cx({
                          //   "u-strike": isPremium && amount && discount,
                          // })}
                          >
                            {amount || "-"}
                          </td>
                          {/* <td
                            className={cx("u-brand", {
                              "u-strike": !isPremium && discount,
                            })}
                          >
                            {amountDiscounted || "-"}
                          </td> */}
                          <td>
                            {rate.shots === -1
                              ? "Unlimited"
                              : rate.shots || "-"}
                          </td>
                          <td>
                            {!active && !disabled && (
                              <ButtonBasic
                                small
                                title="Select"
                                className="u-xsmall"
                                disabled={offline}
                                mod="brand"
                                onClick={(ev) =>
                                  this.changeDuration(rate.duration)
                                }
                              />
                            )}
                            {disabled && rate.id === "__duration__" && (
                              <small style={{ fontWeight: "normal" }}>
                                Not available
                              </small>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {!expanded && remaining > 0 && (
                  <a
                    className="u-small"
                    onClick={(ev) => this.expandRates(tab)}
                  >
                    See {remaining} more rates
                  </a>
                )}
              </div>
            )}
            {rates.length === 0 && (
              <Alert
                info
                text={`Sorry ${modelName} does not provide ${tab} services`}
              />
            )}
          </div>
        )}
        {!ratesAllowed && (
          <Alert info text={`Sorry incall is not available in ${city.name}`} />
        )}
      </div>
    );
  }
}

function Tabs({ tabs, active, className, onTabClick }) {
  return (
    <div className={className} style={{ borderBottom: "1px solid gainsboro" }}>
      <ol className="tabs o-list-inline">
        {tabs.map((tab) => (
          <li
            key={tab.id}
            className={cx("tabs__item", { active: tab.id === active })}
            onClick={(ev) => onTabClick(tab.id)}
          >
            {tab.text}
          </li>
        ))}
      </ol>
    </div>
  );
}

// @connect
import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
import { changeDurationAction } from "../modules/booking/actions";
import {
  getCity,
  getDiscounts,
  getModel,
  getModelIncalls,
  getModelOutcalls,
  getModelRate,
  isComplimentaryCity,
  isPremiumIn,
} from "../selectors";

const state = (state) => {
  // Prevents re-reselect selectors to be triggered below
  // Return empty: Component won't update (@see shouldComponentUpdate)
  if (!state.models.active) {
    return {};
  }

  const { booking } = state;
  const model = getModel(state);

  return {
    discounts: getDiscounts(state),
    modelName: _get(model, "name"),
    offline: !model.online,
    rate: getModelRate(state),
    duration: booking.duration,
    outcall: booking.outcall,
    incalls: getModelIncalls(state) || [],
    outcalls: getModelOutcalls(state) || [],
    isPremium: isPremiumIn(state),
    city: getCity(state),
    isComplimentaryCity: isComplimentaryCity(state),
  };
};

const actions = (dispatch) =>
  bindActions({ changeDuration: changeDurationAction }, dispatch);

export default connect(state, actions)(ModelRates);
